module.exports = __webpack_public_path__ + "static/media/logo.1f34b5b0.png";